import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { getSelectedDatasetOptions, unselectSelectedDataset } from '@stores/graphViewPageSlice';
import { STATE_STATUS } from '@awp/constants';
import { selectStatus, selectData } from '@stores/dataVisualizationSlice';
import LegendModal from '@components/dataTables/LegendModal';
import { OverlayTrigger, Popover, ListGroup } from 'react-bootstrap';

const DatasetLegend = ({ graphId }) => {
  const graphKey = graphId.slice(0, graphId.lastIndexOf('_'));
  const status = useSelector(selectStatus);
  const [legend, setLegend] = useState([]);
  const data = useSelector(selectData);

  const selectedDatasets = useSelector((state) => getSelectedDatasetOptions(state, graphKey));
  //TODO: Future sorty WEAV-10193 we need to add sorting for the datasets here before rendering the datasets

  //seperate the datasets into groups based on their value
  const sortedSelectedDatasets = Object.values(
    selectedDatasets.reduce((groups, item) => {
      // sort by item value prefix; 0 = dataset, 1 = images, 2 =??
      const key = item.value.split('_')[0];

      if (!groups[key]) groups[key] = [];

      groups[key].push({ ...item, sortLabel: `${item.label} (${item.name})` });
      return groups;
    }, {}),
  )
    .map((group) => {
      const sortedGroup = group.sort((a, b) => {
        // if (a.name < b.name) {
        // 	return -1;
        // } else if (a.name > b.name) {
        // 	return 1;
        // } else {
        return a.sortLabel.localeCompare(b.sortLabel);
        //}
      });
      return sortedGroup;
    })
    .flat();

  const dispatch = useDispatch();

  const showLegend = (legendData) => {
    setLegend(legendData);
  };

  const renderListItem = (dataset, idx) => {
    const datasetLabel = dataset.label + ' (' + dataset.name + ')';
    const legendData = data.Datasets.find((ds) => ds.DatasetId === dataset.value)?.graphConfig?.yAxisTickList;

    const legendItemColor = legendData ? (
      <OverlayTrigger
        key={`${dataset.DatasetId}_${idx}`}
        placement="bottom"
        overlay={
          <Popover id={`popover_${dataset.DatasetId}`}>
            <Popover.Content>
              <p className="text-left m-0 p-0">Click to see legend</p>
            </Popover.Content>
          </Popover>
        }
      >
        <span
          className="legend__item__color"
          style={{
            background: dataset.color,
            borderColor: dataset.color,
          }}
          onClick={() => showLegend(legendData)}
        ></span>
      </OverlayTrigger>
    ) : (
      <span
        className="legend__item__color"
        style={{
          background: dataset.color,
          borderColor: dataset.color,
        }}
      ></span>
    );

    return (
      <ListGroup.Item key={`${dataset.value}_${idx}`} className="legend__item">
        <span className="legend__item__container">{legendItemColor}</span>
        <span
          className="legend__item__label"
          onClick={(e) => deleteDatasetAction(dataset, e)}
        >{`${datasetLabel}`}</span>
      </ListGroup.Item>
    );
  };

  const deleteDatasetAction = (dataset) => {
    dispatch(
      unselectSelectedDataset({
        datasetId: dataset.value,
        group: dataset.name,
        obsId: dataset.obstypeid,
        graphKey: graphKey,
      }),
    );
  };

  return (
    <>
      {status.data === STATE_STATUS.SUCCESS ? (
        <ListGroup variant="flush" id={graphId + '_LegendList'} className="legend__list">
          {sortedSelectedDatasets.map((dataset, idx) => renderListItem(dataset, idx))}
        </ListGroup>
      ) : (
        <span></span>
      )}
      <LegendModal legend={legend} setLegend={setLegend} />
    </>
  );
};

DatasetLegend.propTypes = {
  graphId: PropTypes.any.isRequired,
};

export default DatasetLegend;
